export const adminUser: AdminUser = {
  dev: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 24, 25, 209, 378, 443, 781],
  prd: [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16, 17, 22, 23, 26, 31, 32
  ]
};

type AdminUser = {
  [key: string]: Number[];
};
